export default {
  getMedia: (object) => {
    return {
      src: object ? object.fields.file.url : ''
    }
  },
  convertLink: (string) => {
    return {
      url: string.split(',')[0],
      text: string.split(',')[1] ? string.split(',')[1] : string.split(',')[0]
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/Help.js